// Lấy vị trí hiện tại của trình duyệt (Promise hóa navigator.geolocation)
export const getCurrentPosition = (options = {}) =>
  new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error("Trình duyệt không hỗ trợ định vị GPS"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        }),
      (err) => {
        const map = {
          1: "Bạn đã từ chối quyền truy cập vị trí. Vui lòng cho phép để chấm công.",
          2: "Không xác định được vị trí. Vui lòng thử lại.",
          3: "Hết thời gian lấy vị trí. Vui lòng thử lại.",
        };
        reject(new Error(map[err?.code] || "Không lấy được vị trí GPS"));
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0, ...options }
    );
  });

// Khoảng cách haversine giữa 2 điểm (mét)
export const distanceInMeters = (a, b) => {
  const R = 6371000;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

// Tất cả địa điểm hợp lệ trong bán kính, kèm distance, sắp xếp gần -> xa
// (places có location.coordinates = [lng, lat])
export const getValidPlaces = (userLoc, places = [], radius = 200) => {
  const valid = [];
  for (const place of places) {
    const coords = place?.location?.coordinates;
    if (!Array.isArray(coords) || coords.length < 2) continue;
    const target = { lat: coords[1], lng: coords[0] };
    const distance = distanceInMeters(userLoc, target);
    if (distance <= radius) valid.push({ ...place, distance });
  }
  return valid.sort((a, b) => a.distance - b.distance);
};

// Tìm địa điểm gần nhất trong bán kính
export const findNearestPlace = (userLoc, places = [], radius = 200) =>
  getValidPlaces(userLoc, places, radius)[0] || null;
